import { FunctionComponent } from 'react';
import Keyboard, { KeyboardOptions, SimpleKeyboard } from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import './keyboard.css';

type KeyboardWrapperProps = {
  keyboardRef: (r: SimpleKeyboard) => void;
} & KeyboardOptions;

const KeyboardWrapper: FunctionComponent<KeyboardWrapperProps> = ({ keyboardRef, ...props }) => <Keyboard keyboardRef={keyboardRef} {...props} />;

export default KeyboardWrapper;
